import { motion } from "motion/react";

const reasons = [
  {
    icon: "ri-map-pin-line",
    title: "Empresa local desde 2015",
    text: "Más de 10 años trabajando en Málaga y la Costa del Sol. Taller propio en San Andrés, Málaga capital.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Garantía 2 años",
    text: "En piezas y mano de obra. Si algo falla, volvemos sin coste adicional.",
  },
  {
    icon: "ri-user-voice-line",
    title: "Sin intermediarios",
    text: "Hablas directamente con el técnico que repara, sin call centers ni plataformas.",
  },
];

export default function SocialProofSection() {
  return (
    <section className="bg-white py-16 md:py-24 border-y border-border">
      <div className="max-w-container mx-auto px-4 md:px-6">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h2 className="font-heading font-extrabold text-3xl md:text-4xl text-text-primary mb-3">
            Por qué elegirnos
          </h2>
          <div className="w-10 h-1 bg-primary mx-auto rounded-full"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {reasons.map((r, i) => (
            <motion.div
              key={r.title}
              className="bg-surface-alt rounded-2xl p-8 border border-border/50 flex flex-col"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
            >
              <div className="w-12 h-12 bg-primary/10 text-primary rounded-xl flex items-center justify-center mb-5">
                <i className={`${r.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading font-bold text-xl text-text-primary mb-3">
                {r.title}
              </h3>
              <p className="font-body text-[15px] text-text-secondary leading-relaxed flex-1">
                {r.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}